export function filterDateRangeHelper(rangeType: String) {
    let today = new Date(); // Date with time offset 0
    let todayCopy = new Date();
    let dateRangeFrom: Date | null = null;
    let dateRangeTo: Date | null = null;

    switch (rangeType) {
        case 'Today': {
            dateRangeFrom = today;
            dateRangeTo = today;
            break;
        }
        case 'Yesterday': {
            const yesterday = new Date(todayCopy);
            yesterday.setDate(todayCopy.getDate() - 1);
            dateRangeFrom = yesterday;
            dateRangeTo = yesterday;
            break;
        }
        case 'Tomorrow': {
            const tomorrow = new Date(todayCopy);
            tomorrow.setDate(todayCopy.getDate() + 1);
            dateRangeFrom = tomorrow;
            dateRangeTo = tomorrow;
            break;
        }
        case 'This Week': {
            const firstDayOfWeek = getStartOfWeek(today);
            dateRangeFrom = firstDayOfWeek;
            dateRangeTo = today;
            break;
        }
        case 'This Week-to-date':{
            dateRangeFrom = getStartOfWeek(today);
            dateRangeTo = today;
            break;
        }
        case 'Last Week': {
            const lastWeekEnd = getEndOfWeek(today);
            const lastWeekStart = new Date(lastWeekEnd);
            lastWeekStart.setDate(lastWeekEnd.getDate() - 7);
            dateRangeFrom = lastWeekStart;
            dateRangeTo = lastWeekEnd;
            break;
        }
        case 'Last 7 Days':
            dateRangeFrom = new Date(todayCopy.setDate(todayCopy.getDate() - 7));
            dateRangeTo = today;
            break;
        case 'Last 15 Days':
            dateRangeFrom = new Date(todayCopy.setDate(today.getDate() - 15));
            dateRangeTo = today;
            break;
        case 'Last 30 Days':
            dateRangeFrom = new Date(todayCopy.setDate(today.getDate() - 30));
            dateRangeTo = today;
            break;
        case 'Last 60 Days':
            dateRangeFrom = new Date(todayCopy.setDate(today.getDate() - 60));
            dateRangeTo = today;
            break;
        case 'Last 90 Days':
            dateRangeFrom = new Date(todayCopy.setDate(today.getDate() - 90));
            dateRangeTo = today;
            break;
        case 'Last Week-to-date': {
            const weekStartsOnMonday = false;
            const currentDay = today.getDay();
          
            const offset = weekStartsOnMonday ? (currentDay === 0 ? -6 : 1 - currentDay) : -currentDay;
          
            const startOfCurrentWeek = new Date(today);
            startOfCurrentWeek.setDate(today.getDate() + offset);
          
            const startOfLastWeek = new Date(startOfCurrentWeek);
            startOfLastWeek.setDate(startOfCurrentWeek.getDate() - 7);
          
            const sameWeekdayAsTodayLastWeek = new Date(startOfLastWeek);
            sameWeekdayAsTodayLastWeek.setDate(startOfLastWeek.getDate() + (weekStartsOnMonday ? (currentDay === 0 ? 6 : currentDay - 1) : currentDay));
          
            dateRangeFrom = startOfLastWeek;
            dateRangeTo = sameWeekdayAsTodayLastWeek;
            break;
        }
        case 'Next Week': {
            const nextWeekStart = getStartOfWeek(today);
            nextWeekStart.setDate(nextWeekStart.getDate() + 7);
            dateRangeFrom = nextWeekStart;
            dateRangeTo = new Date(nextWeekStart.getFullYear(), nextWeekStart.getMonth(), nextWeekStart.getDate() + 6); // End of next week
            break;
        }
        case 'Next Week-to-date': {
            const startOfNextWeek = getStartOfWeek(today);
            startOfNextWeek.setDate(startOfNextWeek.getDate() + 7); // Start of next week
            dateRangeFrom = startOfNextWeek;
  
            const endOfNextWeek = new Date(startOfNextWeek);
            endOfNextWeek.setDate(endOfNextWeek.getDate() + (today.getDay())); // Same day in next week
            dateRangeTo = endOfNextWeek;
            break;
        }
        case 'This Month': {
            const firstDayOfMonth = new Date(todayCopy);
            firstDayOfMonth.setDate(1);
            dateRangeFrom = firstDayOfMonth;
            dateRangeTo = new Date(today.getFullYear(), today.getMonth() + 1, 0);
            break;
        }
        case 'This Month-to-date': {
            dateRangeFrom = new Date(today.getFullYear(), today.getMonth(), 1);
            dateRangeTo = today;
            break;
        }
        case 'Last Month': {
            dateRangeFrom = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            dateRangeTo = new Date(today.getFullYear(), today.getMonth(), 0);
            break;
        }
        case 'Last Month-to-date': {
            const year = today.getFullYear();
            const currentMonth = today.getMonth(); // 0-based
            const lastMonth = currentMonth - 1;
          
            const startOfLastMonth = new Date(year, lastMonth, 1);
          
            const lastDayOfLastMonth = new Date(year, currentMonth, 0).getDate(); 
            const day = Math.min(today.getDate(), lastDayOfLastMonth);
            const toDateLastMonth = new Date(year, lastMonth, day);
          
            dateRangeFrom = startOfLastMonth;
            dateRangeTo = toDateLastMonth;
            break;
        }
        case 'Next Month': {
            dateRangeFrom = new Date(today.getFullYear(), today.getMonth() + 1, 1);
            dateRangeTo = new Date(today.getFullYear(), today.getMonth() + 2, 0);
            break;
        }
        case 'Next Month-to-date': {
            const year = today.getFullYear();
            const month = today.getMonth();
            const startOfNextMonth = new Date(year, month + 1, 1);
          
            const dayOfMonth = today.getDate();
            const lastDayOfNextMonth = new Date(year, month + 2, 0).getDate();
            const toDateDay = Math.min(dayOfMonth, lastDayOfNextMonth);
          
            const sameDayNextMonth = new Date(year, month + 1, toDateDay);
          
            dateRangeFrom = startOfNextMonth;
            dateRangeTo = sameDayNextMonth;
              break;
        }
        case 'This Fiscal Quarter': {
            const quarter = getQuarter(today);
            const { start } = getQuarterStartEnd(today.getFullYear(), quarter);
            dateRangeFrom = start;
            dateRangeTo = today;
            break;
        }
        case 'Last Fiscal Quarter': {
            const lastQuarter = getQuarter(today) - 1 < 0 ? 3 : getQuarter(today) - 1;
            const { start, end } = getQuarterStartEnd(today.getFullYear(), lastQuarter);
            dateRangeFrom = start;
            dateRangeTo = end;
            break;
        }
        case 'Last Fiscal Quarter-to-date': {
            let currentQuarter = getQuarter(today); // 1 to 4
            let lastQuarter = currentQuarter - 1;
            let year = today.getFullYear();
          
            if (lastQuarter === 0) {
              lastQuarter = 4;
              year -= 1;
            }
          
            const { start: startOfLastQuarter } = getQuarterStartEnd(year, lastQuarter);
          
            const { start: startOfCurrentQuarter } = getQuarterStartEnd(today.getFullYear(), currentQuarter);
            const dayOffset = Math.floor((today.getTime() - startOfCurrentQuarter.getTime()) / (1000 * 60 * 60 * 24));
          
            const toDateInLastQuarter = new Date(startOfLastQuarter);
            toDateInLastQuarter.setDate(toDateInLastQuarter.getDate() + dayOffset);
          
            const { end: endOfLastQuarter } = getQuarterStartEnd(year, lastQuarter);
            if (toDateInLastQuarter > endOfLastQuarter) {
              toDateInLastQuarter.setTime(endOfLastQuarter.getTime());
            }
          
            dateRangeFrom = startOfLastQuarter;
            dateRangeTo = toDateInLastQuarter;
            break;
        }
        case 'Next Fiscal Quarter': {
            const nextQuarter = getQuarter(today) + 1 > 3 ? 0 : getQuarter(today) + 1;
            const { start } = getQuarterStartEnd(today.getFullYear(), nextQuarter);
            dateRangeFrom = start;
            dateRangeTo = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 89); // Approx end of quarter
            break;
        }
        case 'Next Fiscal Quarter-to-date': {
            const currentQuarter = getQuarter(today); // 1-based: 1 to 4
            let nextQuarter = currentQuarter + 1;
            let year = today.getFullYear();
          
            if (nextQuarter > 4) {
              nextQuarter = 1;
              year += 1;
            }
          
            const { start: startOfNextQuarter, end: endOfNextQuarter } = getQuarterStartEnd(year, nextQuarter);
            const { start: startOfCurrentQuarter } = getQuarterStartEnd(today.getFullYear(), currentQuarter);
          
            const dayOffset = Math.floor((today.getTime() - startOfCurrentQuarter.getTime()) / (1000 * 60 * 60 * 24));
          
            const toDateInNextQuarter = new Date(startOfNextQuarter);
            toDateInNextQuarter.setDate(toDateInNextQuarter.getDate() + dayOffset);
          
            if (toDateInNextQuarter > endOfNextQuarter) {
              toDateInNextQuarter.setTime(endOfNextQuarter.getTime());
            }
          
            dateRangeFrom = startOfNextQuarter;
            dateRangeTo = toDateInNextQuarter;
            break;
        }
        case 'This Fiscal Year': {
            const startOfYear = new Date(today.getFullYear(), 0, 1);
            dateRangeFrom = startOfYear;
            dateRangeTo = today;
            break;
        }
        case 'Last Fiscal Year': {
            const lastYear = today.getFullYear() - 1;
            const startOfLastYear = new Date(lastYear, 0, 1);
            const endOfLastYear = new Date(lastYear, 11, 31);
            dateRangeFrom = startOfLastYear;
            dateRangeTo = endOfLastYear;
            break;
        }
        case 'Last Fiscal Year-to-date': {
            const lastYear = today.getFullYear() - 1;
        
            // Start of last fiscal year (Jan 1)
            const startOfLastFiscalYear = new Date(lastYear, 0, 1);
          
            // "To date" in last fiscal year, same month/day as today
            let toDateLastFiscalYear = new Date(lastYear, today.getMonth(), today.getDate());
          
            // Clamp to end of last fiscal year in case today’s date (e.g., Feb 29) doesn’t exist in last year
            const endOfLastFiscalYear = new Date(lastYear, 11, 31);
            if (toDateLastFiscalYear > endOfLastFiscalYear) {
              toDateLastFiscalYear = endOfLastFiscalYear;
            }
          
            dateRangeFrom = startOfLastFiscalYear;
            dateRangeTo = toDateLastFiscalYear;
            break;
        }
        case 'This Fiscal Year-to-date': {
            const startOfYear = new Date(today.getFullYear(), 0, 1);
            dateRangeFrom = startOfYear;
            dateRangeTo = today;
            break;
        }
        case 'This Fiscal Year-to-Last Month':{
            const startOfYear = new Date(today.getFullYear(), 0, 1);
            dateRangeFrom = startOfYear;
            dateRangeTo = new Date(today.getFullYear(), today.getMonth(), 0);
            break;
        }
        case 'Next Fiscal Year': {
            const nextYear = today.getFullYear() + 1;
            const startOfNextYear = new Date(nextYear, 0, 1);
            dateRangeFrom = startOfNextYear;
            dateRangeTo = new Date(nextYear, 11, 31); // End of the next year
            break;
        }
        case 'Next Fiscal Year-to-date': {
            const nextYear = today.getFullYear() + 1;
            const startOfNextFiscalYear = new Date(nextYear, 0, 1);
            let endOfToDate = new Date(nextYear, today.getMonth(), today.getDate());
            const endOfNextFiscalYear = new Date(nextYear, 11, 31);
            if (endOfToDate > endOfNextFiscalYear) {
              endOfToDate = endOfNextFiscalYear;
            }
          
            dateRangeFrom = startOfNextFiscalYear;
            dateRangeTo = endOfToDate;
            break;
        }
        case 'Custom': {
            dateRangeFrom = null;
            dateRangeTo = null;
            break;
        }
        default: {
            dateRangeFrom = null;
            dateRangeTo = null;
            break;
        }
    }

    return {
        dateRangeFrom: dateRangeFrom,
        dateRangeTo: dateRangeTo
    };
}
// Get the start of the week (Sunday)
function getStartOfWeek(date: Date): Date {
    const startOfWeek = new Date(date);
    const day = startOfWeek.getDay();
    const diff = startOfWeek.getDate() - day;
    startOfWeek.setDate(diff);
    startOfWeek.setHours(0, 0, 0, 0);
    return startOfWeek;
}

// Get the end of the week (Saturday)
function getEndOfWeek(date: Date): Date {
    const endOfWeek = new Date(date);
    const day = endOfWeek.getDay();
    const diff = endOfWeek.getDate() + (6 - day);
    endOfWeek.setDate(diff);
    endOfWeek.setHours(23, 59, 59, 999);
    return endOfWeek;
}

// Get the quarter for a given date (returns 0 for Q1, 1 for Q2, etc.)
function getQuarter(date: Date): number {
    const month = date.getMonth();
    return Math.floor(month / 3);
}

// Get the start and end dates of a given quarter
function getQuarterStartEnd(year: number, quarter: number): { start: Date, end: Date } {
    const startMonth = quarter * 3;
    const endMonth = startMonth + 2;
    const start = new Date(year, startMonth, 1);
    const end = new Date(year, endMonth + 1, 0);
    return { start, end };
}

// Get the fiscal year start and end for a given year
function getFiscalYearStartEnd(year: number): { start: Date, end: Date } {
    const start = new Date(year, 0, 1);  // Start of fiscal year
    const end = new Date(year, 11, 31);  // End of fiscal year
    return { start, end };
}

// Get the start of the next fiscal year
function getStartOfNextFiscalYear(year: number): Date {
    return new Date(year + 1, 0, 1);  // Start of next fiscal year
}
